exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".appeal-bill-modal[data-v-437f5572] .el-dialog__body{max-height:calc(100vh - 250px);padding-top:10px;overflow-y:auto}.appeal-bill-modal .appeal-bill-block .detail-container[data-v-437f5572]{line-height:42px;padding:8px 12px;margin-bottom:20px}.appeal-bill-modal .thumb-image[data-v-437f5572]{width:102px;height:102px}.appeal-bill-modal .thumb-image[data-v-437f5572]:not(:last-child){margin-right:15px}.appeal-bill-modal .thumb-image[data-v-437f5572]:hover{cursor:pointer}\n", ""]);

// exports
